import React from 'react';

const Legend = ({ children }) => <legend className="u-a11y">{children}</legend>;

export default Legend;
